<template>
  <section class="progress-bar" aria-label="Playback progress">
    <div class="progress-meta">
      <span>{{ formatTime(currentTime) }}</span>
      <strong>{{ trackTitle }}</strong>
      <span>{{ formatTime(duration) }}</span>
    </div>
    <button
      class="timeline"
      type="button"
      :disabled="!duration"
      aria-label="Seek through track"
      @click="seek"
    >
      <span class="timeline-fill" :style="{ width: `${percent}%` }"></span>
    </button>
  </section>
</template>

<script setup>
/* global defineProps, defineEmits */
defineProps({
  currentTime: {
    type: Number,
    default: 0,
  },
  duration: {
    type: Number,
    default: 0,
  },
  percent: {
    type: Number,
    default: 0,
  },
  trackTitle: {
    type: String,
    default: 'No Track Selected',
  },
})

const emit = defineEmits(['seek'])

function seek(event) {
  const rect = event.currentTarget.getBoundingClientRect()
  const ratio = (event.clientX - rect.left) / rect.width
  emit('seek', Math.min(1, Math.max(0, ratio)))
}

function formatTime(time) {
  const value = Number.isFinite(time) ? time : 0
  const min = Math.floor(value / 60)
  const sec = Math.floor(value % 60)
  return `${String(min).padStart(2, '0')}:${String(sec).padStart(2, '0')}`
}
</script>

<style scoped lang="less">
.progress-bar {
  position: relative;
  z-index: 1;
  margin-top: 22px;
}

.progress-meta {
  display: grid;
  grid-template-columns: 48px minmax(0, 1fr) 48px;
  align-items: center;
  margin-bottom: 10px;
  color: #918987;
  font-size: 11px;
}

.progress-meta strong {
  overflow: hidden;
  color: #d6cfcb;
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0;
  text-align: center;
  text-overflow: ellipsis;
  text-transform: uppercase;
  white-space: nowrap;
}

.progress-meta span:last-child {
  text-align: right;
}

.timeline {
  position: relative;
  display: block;
  width: 100%;
  height: 12px;
  margin: 0;
  border: 0;
  background: transparent;
  cursor: pointer;
}

.timeline::before {
  content: '';
  position: absolute;
  top: 50%;
  right: 0;
  left: 0;
  height: 4px;
  border-radius: 4px;
  background: rgba(255, 255, 255, 0.12);
  transform: translateY(-50%);
}

.timeline[disabled] {
  cursor: not-allowed;
}

.timeline-fill {
  position: absolute;
  top: 50%;
  bottom: auto;
  left: 0;
  height: 4px;
  border-radius: 4px;
  background: linear-gradient(90deg, #c32936, #f15d4b);
  transform: translateY(-50%);
}
</style>
